import React, { ReactNode } from 'react';
import styled from 'styled-components';

import theme from '@/styles/theme';

interface Props {
  icon?: ReactNode;
  text: string;
  buttonText?: string;
  onClick?: () => void;
  useButton?: boolean;
}
const EmptyNotice = ({ icon, text, buttonText, onClick, useButton = true }: Props) => {
  return (
    <Container key={`empty-${text}`}>
      <Wrapper>
        {icon}
        <Text>{text}</Text>
        {useButton && <Button onClick={onClick}>{buttonText}</Button>}
      </Wrapper>
    </Container>
  );
};

export default EmptyNotice;

const Container = styled.section`
  padding: 16px 24px;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
`;

const Text = styled.p`
  ${theme.typography.UI16R}
  color: ${theme.color.gray700};
  white-space: pre-wrap;
  text-align: center;
  margin-top: 8px;
`;

const Button = styled.button`
  ${theme.typography.UI16SB}
  color: ${theme.color.primary700};
  background-color: ${theme.color.primary100};
  padding: 8px 16px;
  margin-top: 16px;
  border-radius: 8px;
`;
